import gql from 'graphql-tag';
import BannerListItemFragment from '../fragments/BannerListItemFragment';

export default gql`
mutation createBanner (
    $name: String!
    $active_from: DateTime
    $active_to: DateTime
    $url: String!
    $url_target: BannerUrlTarget!
    $image_url_desktop: String!
    $image_url_mobile: String!
    $is_active: Boolean!
    $priority: Int!
    $banner_place_ids: [ID!]!
) {
    createBanner (input: {
        name: $name,
        active_from: $active_from,
        active_to: $active_to
        url: $url,
        url_target: $url_target,
        image_url_desktop: $image_url_desktop,
        image_url_mobile: $image_url_mobile,
        is_active: $is_active,
        priority: $priority,
        banner_place_ids: $banner_place_ids
    }) {
        ...BannerListItemFragment
    }
}
${BannerListItemFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/createBanner.ts